import { useEffect, useRef } from 'react';
import { usePrefs } from '../../application/stores/prefsStore';
import { useAuth } from './useAuth';

/** Saves language/theme changes made on this device to the signed-in user's profile. */
export function PrefsSync() {
  const { user, updateProfile } = useAuth();
  const locale = usePrefs((s) => s.locale);
  const theme = usePrefs((s) => s.theme);
  const timer = useRef<ReturnType<typeof setTimeout>>();
  useEffect(() => {
    if (!user || (user.locale === locale && user.theme === theme)) return;
    clearTimeout(timer.current);
    timer.current = setTimeout(
      () => void updateProfile({ locale, theme }).catch(() => undefined),
      500,
    );
    return () => clearTimeout(timer.current);
  }, [user, locale, theme, updateProfile]);
  return null;
}
